<template>
  <button
    class="custom-button"
    :class="{
      'is-transparent': transparent,
      'is-dark': dark,
      'with-border': withBorder,
      'is-hover': hover,
      'is-selected': selected,
      'round': round,
      'is-disabled': disabled,
    }"
    type="button"
    tabindex="0"
    @click.stop="!disabled ? $emit('click') : null"
    @mouseover="!disabled ?$emit('mouseover') : null"
    @mouseleave="!disabled ? $emit('mouseleave') : null"
  >
    <span class="custom-button-effect" :style="bgStyle" />
    <span class="custom-button-content" :style="colorStyle">
      <slot :style="colorStyle" />
    </span>
  </button>
</template>

<script>
export default {
  name: 'YearMonthButton',
  props: {
    color: { type: String, default: '#050817' },
    dark: { type: Boolean, default: false },
    withBorder: { type: Boolean, default: false },
    hover: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
  },
  computed: {
    colorStyle() {
      const color = this.disabled ? 'white' : this.color;
      return {
        color,
        fill: color,
      };
    },
    bgStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/datepicker.scss";

.custom-button {
  display: flex;
  align-items:center;
  justify-content: center;

  padding: 0px 20px;
  position: relative;
  font-family: $font-family-grotesk;
  font-size: 16px;
  font-weight: 400;

  background-color: $stoneWhite;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 32px;

  outline: none;
  cursor: pointer;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #FFF;

  @include dp-mobile-down-sm(){
    padding: 0px 10px;
    font-size: 15px;
  }

  &-content {
    position: relative;
    display: flex;
    align-items:center;
    justify-content: center;
  }
  svg {
    position: relative;
    -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    fill: $yellowStone;
  }
  .custom-button-effect {
    position: absolute;
    background: $yellowStone;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 30px;
    border-radius: 4px;
    width: 100%;
    -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    transform: scale(0);
  }
  &.with-border {
    border: 1px solid $stoneCream;
  }
  &:hover:not(.is-disabled),
  &.is-hover:not(.is-disabled) {
    border: 1px solid transparent !important;
    .custom-button-effect {
      transform: scale(1);
      opacity: (.6);
    }
    svg {
      fill: white !important;
    }
    .custom-button-content {
      color: $darkBlack !important;
    }
  }

  &.is-disabled {
    cursor: auto;
    opacity: 0.5;
    //cursor:  not-allowed;
    svg {
      fill: none !important;
    }
  }

  &.is-selected {
    border: 1px solid transparent !important;
    .custom-button-effect {
      transform: scale(1);
      opacity: (1);
    }
    svg {
      fill: $stoneWhite !important;
    }
    .custom-button-content {
      color: $darkBlack !important;
    }
  }
  &.is-transparent {
    background-color: transparent;
    color: $stoneWhite;

    &.with-border {
      border-color: $stoneCream;
    }
    svg {
      fill: rgb(201, 193, 193) !important;
    }
  }
  &.round {
    padding: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    .custom-button-effect {
      border-radius: 50%;
      height: 24px;
    }
  }
}
</style>
